import Vue from 'vue'
export default {
  state: {
    groups: {},
    displaySelector: {},
    subscribables: {},
    groupOperators: {},
  },
  mutations: {
    CLEAR_GROUPS (state) {
      state.groups = {}
    },
    SET_GROUP (state, { name, max, term, index, selector }) {
      Vue.set(state.groups, `${name}-${term ?? ''}`, { name, max, term, index, selector })
    },
    DELETE_GROUP (state, { name, term }) {
      Vue.delete(state.groups, `${name}-${term ?? ''}`)
    },
    CLEAR_SELECTOR_SUBSCRIBABLES (state) {
      state.subscribables = {}
    },
    SET_SELECTOR_SUBSCRIBABLES (state, subscribables) {
      state.subscribables = subscribables
    },
    SET_DISPLAY_SELECTOR_REFERENCE (state, { reference, display }) {
      Vue.set(state.displaySelector, reference, display)
    },
    DELETE_DISPLAY_SELECTOR_REFERENCE (state, reference) {
      Vue.delete(state.displaySelector, reference)
    },
    CLEAR_GROUPS_OPERATORS (state) {
      state.groupOperators = {}
    },
    SET_GROUP_OPERATOR (state, { reference, groupCategory }) {
      Vue.set(state.groupOperators, reference, groupCategory)
    },
  },
  actions: {
    clear_groups ({ commit }) {
      commit('CLEAR_GROUPS')
    },
    set_group ({ commit }, { name, max, term, index, selector }) {
      commit('SET_GROUP', { name, max, term, index, selector })
    },
    delete_group ({ commit }, { name, term }) {
      commit('DELETE_GROUP', { name, term })
    },
    set_selector_subscribables ({ commit }, subscribables) {
      commit('CLEAR_SELECTOR_SUBSCRIBABLES')
      commit('SET_SELECTOR_SUBSCRIBABLES', subscribables)
    },
    set_display_selector_reference ({ commit }, { reference, display }) {
      commit('SET_DISPLAY_SELECTOR_REFERENCE', { reference, display })
    },
    delete_display_selector_reference ({ commit }, reference) {
      commit('DELETE_DISPLAY_SELECTOR_REFERENCE', reference)
    },
    clear_groups_operators ({ commit }) {
      commit('CLEAR_GROUPS_OPERATORS')
    },
    set_group_operator ({ commit }, { reference, groupCategory }) {
      commit('SET_GROUP_OPERATOR', { reference, groupCategory })
    },
  },
}
